<template>
    <div>
        <div class="scrollable-container border-0 rounded right-0 top-0 overflow-y-auto overflow-x-hidden z-60 fixed flex flex-col w-full max-w-xl min-w-0 bg-white h-full">
            <slot name="header"> </slot>
            <div class="border-b border-solid border-lightgrey ml-4 mr-4"></div>
            <div class="popup-content flex-1 min-w-0 overflow-y-auto">
                <slot></slot>
            </div>
                </div>
    </div>
    <div class="opacity-40 fixed inset-0 z-55 bg-black"></div>
</template>
<style scoped>
.scrollable-container {
  height: 100vh;
  overflow-x: hidden;
}
</style>
<script lang="ts">
import { defineComponent } from 'vue';
import _ from 'lodash';
import useVuelidate from '@vuelidate/core';

export default defineComponent({
    props: ['popUp'],
    data(): any {
        return {
            v$: useVuelidate(),
            pop: false
        };
    },
    created() {
        this.pop = this.popUp;
    },
    beforeUnmount(){
         this.pop = !this.popUp;
           if (this.pop == false) {
                document.body.style.overflow = '';
           }
    },
    watch: {
        popUp(newVal,oldVal){
            this.pop = newVal;
        },
        pop(newVal, oldVal) {
             if (newVal == true) {
                document.body.style.overflow = 'hidden';
            }     
        }
    }
});
</script>
